import { axiosInstance, requestConfig } from 'network/apis';

import { URL_SYSTEM } from "utils/constants";

export const callShopGameRoundOptionSetting = async (shopGuid) => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, `/shop/${shopGuid}/game-round-option-setting`));
};

export const callEditShopGameRoundOptionSetting = async (shopGuid, data) => {
    return await axiosInstance(requestConfig('put', URL_SYSTEM, `/shop/${shopGuid}/game-round-option-setting`, data));
};